export default function TextBoxJ ({title, placeholder, height}){
    let mt;
    height === 1 ? mt = '1rem' : mt='4rem';
    return(
        <label className="grid text-[1.3rem] font-montserrat " style={{marginTop: mt}}>
                    {title && <p className="pl-3 mb-3">{title}</p>}
                    <textarea wrap="soft" placeholder={placeholder} rows={height} cols={30} className=" rounded"></textarea>
        </label>
    )
}